// 分享给好友
export const sharefriend = (shareData) => {
	let ua = navigator.userAgent.toLowerCase();
	let isQQ = () => {
		let chkRes = false
		window.mqq.device.isMobileQQ((result) => {
			chkRes = result
		})
		return chkRes
	}
	let isWeixin = /micromessenger/ig.test(ua)
	let sharenow = () => {
		if (isWeixin) {
			let shareAppMessageData = {
				wx_appid: 'wxfb66a4e99e630765',
				title: shareData.title,
				desc: shareData.description,
				link: window.location.href,
				imgUrl: shareData.icon,
				success: function () {
					return 1
				},
				cancel: function () {
					return 0
				}
			}
			let shareTimelineData = {
				title: shareData.title,
				link: shareData.link,
				imgUrl: shareData.icon,
				success: function () {
					return 1
				},
				cancel: function () {
					return 0
				}
			};
			let qqShareData = {
				title: shareData.title,
				desc: shareData.description,
				link: shareData.link,
				imgUrl: shareData.icon,
				success: function () {
					return 1
				},
				cancel: function () {
					return 0
				}
			}
			window.need('biz.mobileclient', function (mClient) {
				mClient.shareAll(shareAppMessageData);
			});
			// 朋友圈及好友分享
			// window.need('biz.wxclient', function (WXClient) {
			// 	// 微信客户初始化成功后，返回wx对象
			// 	WXClient.init({sAppId: 'wxfb66a4e99e630765'}, function (wx) {
			// 		// 分享到朋友
			// 		wx.onMenuShareAppMessage(shareAppMessageData);
			// 		// 分享到朋友圈
			// 		wx.onMenuShareTimeline(shareTimelineData);
			// 		// 分享到手Q
			// 		wx.onMenuShareQQ(qqShareData);
			// 		// 分享到QZone
			// 		wx.onMenuShareQZone(qqShareData);
			// 		// 分享到微博（默认是不需要的，可根据情况使用）
			// 		wx.onMenuShareWeibo(qqShareData);
			// 	});
			// });
		} else if (isQQ) {
			window.mqq.ui.setOnShareHandler(function (type) {
				switch (type + '') {
				case '0':
					window.mqq.ui.shareMessage({
						title: shareData.title,
						desc: shareData.description,
						share_type: type,
						back: true,
						share_url: shareData.link,
						image_url: shareData.icon
					}, function (result) {
						if (result.retCode === '0') {
							alert('分享成功！')
							return 1
						}
					})
					break
				case '1':
					window.mqq.ui.shareMessage({
						title: shareData.title,
						desc:	shareData.description,
						share_type: type,
						back: true,
						share_url: shareData.link,
						image_url: shareData.icon
					}, function (result) {
						if (result.retCode === '0') {
							alert('分享成功！')
							return 1
						}
					});
					break
				case '2':
					window.mqq.ui.shareMessage({
						title: shareData.title,
						desc:	shareData.description,
						share_type: type,
						back: true,
						share_url: shareData.link,
						image_url: shareData.icon
					}, function (result) {
						if (result.retCode === '0') {
							alert('分享成功！')
							return 1
						}
					});
					break
				case '3':
					window.mqq.ui.shareMessage({
						title: shareData.title,
						desc:	shareData.description,
						share_type: type,
						back: true,
						share_url: shareData.link,
						image_url: shareData.icon
					}, function (result) {
						if (result.retCode === '0') {
							alert('分享成功！')
							return 1
						}
					})
					break
				}
			})
		}
	}
	sharenow()
}

export const gotoApp = (_url) => {
	// 下载心悦APP
	let jumpDownApp = function (delayTime, confirmTxt, callback) {
		setTimeout(function () {
			if (confirmTxt !== false && !confirm(confirmTxt)) {
				if (typeof (callback) !== 'undefined') {
					callback()
				}
				return
			}
			if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
				let appDownUrl = 'https://itunes.apple.com/cn/app/%E5%BF%83%E6%82%A6%E4%BF%B1%E4%B9%90%E9%83%A8-%E8%85%BE%E8%AE%AF%E6%B8%B8%E6%88%8F%E7%8E%A9%E5%AE%B6%E7%A6%8F%E5%88%A9%E5%B9%B3%E5%8F%B0/id1156439976?mt=8'
				window.location.href = appDownUrl
			} else {
				let appDownUrl = 'http://sj.qq.com/myapp/detail.htm?apkName=com.tencent.tgclub'
				window.location.href = appDownUrl
			}
			if (typeof (callback) !== 'undefined') {
				callback()
			}
		}, delayTime)
	}
	let goHelpHimLock = 'unlock'
	let goToApp = () => {
		if (goHelpHimLock === 'lock') {
			return;
		}
		goHelpHimLock = 'lock';
		let url = _url;
		if (window._Vue.$route.query.openidA !== null && window._Vue.$route.query.openidA !== 'null') {
			url += `?openidA=` + window._Vue.$route.query.openidA
		}
		let schemaUrl = 'tgclub://redirect?url=' + encodeURIComponent(url);
		let gsUA = navigator.userAgent.toLowerCase();
		let android = gsUA.match(/(android)\s+([\d.]+)/);
		let ios = gsUA.match(/(ipad|iphone|ipod).*os\s([\d_]+)/);
		let isWeixin = gsUA.match(/micromessenger/);
		let confirmTxt = '下载心悦俱乐部App';
		if (gsUA.indexOf('tgclub') === -1) {
			// 非App环境下执行
			switch (true) {
			case (ios != null && isWeixin != null): // ios微信
				// IOS的微信，使用JSAPI唤起
				setTimeout(function () {
					window.WeixinJSBridge.invoke('launchApplication', {
						'schemeUrl': schemaUrl
					}, function (res) {
					})
				}, 500)
				// 手Q直接跳转
				jumpDownApp(3000, false, function () {
					goHelpHimLock = 'unlock'
				})
				break
			case (ios != null && isWeixin == null): // ios 手Q
				window.location.href = schemaUrl;
				let loadDateTime = Date.now();
				setTimeout(function () {
					let timeOutDateTime = Date.now();
					if (timeOutDateTime - loadDateTime < 1000) {
						if (confirm(confirmTxt)) {
							window.location.href = 'https://itunes.apple.com/cn/app/%E5%BF%83%E6%82%A6%E4%BF%B1%E4%B9%90%E9%83%A8-%E8%85%BE%E8%AE%AF%E6%B8%B8%E6%88%8F%E7%8E%A9%E5%AE%B6%E7%A6%8F%E5%88%A9%E5%B9%B3%E5%8F%B0/id1156439976?mt=8';
						}
					}
				}, 25);
				goHelpHimLock = 'unlock'
				break
			case (android != null && isWeixin != null):// 安卓 微信
				// IOS的1微信，使用JSAPI唤起
				setTimeout(function () {
					window.WeixinJSBridge.invoke('launchApplication', {
						'schemeUrl': schemaUrl
					}, function (res) {
					})
				}, 500)
				// 手Q直接跳转
				jumpDownApp(1500, confirmTxt, function () {
					goHelpHimLock = 'unlock'
				})
				break
			case (android != null && isWeixin == null): // 安卓 手Q
				let iframe = document.createElement('iframe');
				iframe.src = schemaUrl;
				iframe.style.display = 'none';
				document.body.appendChild(iframe);
				// 手Q直接跳转
				jumpDownApp(1500, confirmTxt, function () {
					goHelpHimLock = 'unlock'
				})
				break
			default:
				alert('仅适用IOS或Android')
				goHelpHimLock = 'unlock'
				break
			}
		}
	}
	goToApp()
}



// WEBPACK FOOTER //
// ./src/utils/share.js